import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5qdgan4fgk: FaireBrandEntity = {
  token: "b_5qdgan4fgk",
  type: "brand",
  name: "Healthogenics",
  avatarUrl:
    "https://cdn.faire.com/fastly/69426a14a582586e3ff7280785c67add125d492825ac3be45c4c6f1dcc8a19f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e55c8ea284322049bb53f536afbac5e28074ec9b735cfd0cdafe6231b1a98219.png",
  logoUrl:
    "https://cdn.faire.com/fastly/69426a14a582586e3ff7280785c67add125d492825ac3be45c4c6f1dcc8a19f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e55c8ea284322049bb53f536afbac5e28074ec9b735cfd0cdafe6231b1a98219.png",
  location: "Gainesville, GA, USA",
  minimumOrderDollars: 150,
  rating: 4.7,
  reviewCount: 7,
  isInsider: true,
  description:
    "Healthogenics emerged from extensive experience within the medical weight management sector, having assisted over 100,000 clients in surpassing their weight management objectives, thereby observing significant enhancements in their overall health indicators. Recognizing the broader impact beyond mere weight management, the CEO acknowledged the transformational role the company played in fostering healthier, happier individuals, leading to the inception of Healthogenics. Defined as the science of nurturing individuals toward optimal health, Healthogenics is committed to providing early health testing and evidence-based wellness plans and products to support individuals throughout their journey toward better health outcomes. Beyond individuals, Healthogenics extends its vision to encompass comprehensive health and wellness solutions for families, including children, teenagers, adults, and even beloved pets, underlining the belief that a healthy family fosters happiness.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.037Z",
    importedBy: "entity-db-cli",
  },
};
